// #region COMPONENTS COMPOSABLES
import Register from '../views/register/Register.vue';
// #endregion

export default [
  {
    path: '/registro',
    name: 'Register',
    component: Register,
    meta: {
      title: 'Registro',
      staticBreadCrumbs: [
        {
          text: 'Transporte Terrestre',
          link: 'https://www.transportes.gob.es/transporte_terrestre',
        },
        {
          text: 'Viajeros de autobús y tren',
          link: 'https://www.transportes.gob.es/transporte_terrestre#Viajeros_de_autobus_y_tren',
        },
        {
          key: 'main',
          dynamic: true,
          // text: '',
          // link: STTEDRA_URL_AMPLIFY_INFORMATION || 'https://www.transportes.gob.es/transporte_terrestre/verano-joven',
          link: '',
          route: 'Home',
        },
        {
          text: 'Registro',
          link: '',
          route: '',
        },
      ],
    },
  },
  {
    path: '/registroTutorizado',
    name: 'RegisterTutorize',
    component: Register,
    meta: {
      title: 'Registro Tutorizado',
      staticBreadCrumbs: [
        {
          text: 'Transporte Terrestre',
          link: 'https://www.transportes.gob.es/transporte_terrestre',
        },
        {
          text: 'Viajeros de autobús y tren',
          link: 'https://www.transportes.gob.es/transporte_terrestre#Viajeros_de_autobus_y_tren',
        },
        {
          key: 'main',
          dynamic: true,
          // text: '',
          // link: STTEDRA_URL_AMPLIFY_INFORMATION || 'https://www.transportes.gob.es/transporte_terrestre/verano-joven',
          link: '',
          route: 'Home',
        },
        {
          text: 'Registro',
          link: '',
          route: '',
        },
      ],
    },
  },
];
